<template>
  <div class="tutorial-content-stage" v-if="openedTutorial">
    <div class="heading">
      <i @click="back"></i>
      <span>{{openedTutorial.title}}</span>
    </div>
    <div class="content">
      <p v-for="text, i in splitText()" :key="i">{{text}}</p>
    </div>
    <div class="footer">
      <div class="btn" v-if="openedTutorial.videoUrl" @click="openVideo"><i class="icon icon-video"></i>视频教程</div>
      <div class="btn" v-if="openedTutorial.url" @click="link(openedTutorial.url)"><i class="icon icon-image"></i>图文教程</div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters({
      openedTutorial: 'helpCenter/openedTutorial'
    })
  },
  methods: {
    ...mapActions({
      closeTutorial: 'helpCenter/closeTutorial'
    }),
    back () {
      this.closeTutorial();
    },
    splitText () {
      const text = this.openedTutorial.description || '';
      const texts = text.replace(/^\n/, '').replace(/\n$/, '').split(/\n/);
      return texts;
    },
    link (url) {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
      a.remove();
    },
    openVideo () {
      this.$modal.show('tutorialVideoPopup');
    }
  }
}
</script>

<style scoped lang="scss">
.tutorial-content-stage {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.heading {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background: #F0F0F8;
  opacity: 1;
  border-radius: 4px 4px 0px 0px;
  padding-left: 14px;
  padding-right: 14px;
  font-weight: bold;
  & > i {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    background: url(../../../assets/helpCenter/arrow-back.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
}
.content {
  flex-grow: 1;
  min-height: 266px;
  padding-top: 12px;
  padding-left: 14px;
  padding-right: 14px;
  margin-bottom: 12px;
  overflow: auto;
  text-align: left;
  & > p {
    min-height: 12px;
  }
  & {
    scrollbar-width: auto;
    scrollbar-color: #b8b9bf #ffffff;
  }

  /* Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b8b9bf;
    border-radius: 10px;
    border: 1px solid #ffffff;
  }
}
.footer {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  padding-left: 14px;
  padding-right: 14px;
  padding-bottom: 18px;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 103px;
    height: 32px;
    background: #F4F5F9;
    opacity: 1;
    border-radius: 4px;
    cursor: pointer;
    .icon {
      width: 22px;
      height: 22px;
      margin-top: -1.25px;
      margin-right: 2px;
      &.icon-video {
        background: url(../../../assets/helpCenter/video.svg) center center / 100% 100% no-repeat;
      }
      &.icon-image {
        background: url(../../../assets/helpCenter/image.svg) center center / 100% 100% no-repeat;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/helpCenter/tutorialContentStage.vue